import React, {useEffect, useState, useContext} from "react";
// import { useCookies } from "react-cookie";
import {useParams} from "react-router-dom";
import { Link } from "react-router-dom";
import fetchOptionsBuilder from "../../fetchOptionBuilder";
import '../../styles/pages/strains_details.scss'
import WorkflowContext from "../../workflowContext";
import * as CGV from 'cgview';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);

}

export default function StrainDetailCGView() {

    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);
    const [antibioticTerm, setAntibioticTerm] = useState('');
    const [virulenceTerm, setVirulenceTerm] = useState('');
    const [phenotypeTerm, setPhenotyeTerm] = useState('');
    const [antibioticData, setAntibioticData] = useState([]);
    const [virulenceData, setVirulenceData] = useState([]);
    const [phenotypeData, setPhenotypeData] = useState([]);
    

    let {id} = useParams();

    const filteredAntibioticData = antibioticData.filter(gene => gene.gene_product.toLowerCase().includes(antibioticTerm.toLowerCase()))
    const filteredVirulenceData = virulenceData.filter(gene => gene.gene_name.toLowerCase().includes(virulenceTerm.toLowerCase()))
    const filteredPhenotypeData = phenotypeData.filter(gene => gene.prop.toLowerCase().includes(phenotypeTerm.toLowerCase()))

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));       

    useEffect(() => {
        if (id) {
            const fetchOptions = fetchOptionsBuilder(apitoken, workflow, getDataUserId);
            //get Antibiotic Resistance Genes data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/arg/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setAntibioticData(data));

            //get Virulence Factors data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/vfg/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setVirulenceData(data));

            //get phenotype data
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `strains/${id}/data/json`, fetchOptions)
                .then(response => response.json())
                .then(data => setPhenotypeData(data));
        }
    }, [id, workflow, apitoken, getDataUserId]);

    useEffect(() => {
        document.title = `${id ? id : 'Strain'} | Palmona Pathogenomics`
    }, [id]);

    useEffect(() => {
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `cgview/${id}`, fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.json())
            .then(json => {
                // Create Viewer
                const cgv = new CGV.Viewer('#my-viewer', {
                    height: 250,
                    width: 250
                });
                // Load data
                cgv.io.loadJSON(json);
                cgv.draw();
            });

       

    }, [apitoken, workflow, getDataUserId, id]);


    const renderTableRow = (data) => {
        return (
            <tr>
                <td>{data.gene_name}</td>
                <td>{data.gene_product}</td>
            </tr>
        );
    }

    const renderPhenoTableRow = (data) => {
        return (
            <tr>
                <td>{data.prop}</td>
                <td>{data.val}</td>
            </tr>
        );
    }

    return (
        <div className="screen strain detail">
            <div className="container mt-4 text-secondary">
                <div className="row">
                    <div className="col left">
                        <h1>Strain Detail View</h1>
                        <hr/>
                        {id ? <>
                            <h3 className="pb-2">Strain {id} Gene Categories</h3>
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingOne">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                                                aria-expanded="false" aria-controls="flush-collapseOne">
                                            Antibiotic Resistance Genes ({antibioticData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setAntibioticTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Gene</th>
                                                    <th scope="col">Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredAntibioticData.map((data) => renderTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                                                aria-expanded="false" aria-controls="flush-collapseTwo">
                                            Virulence Factors ({virulenceData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseTwo" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setVirulenceTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Gene</th>
                                                    <th scope="col">Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredVirulenceData.map((data) => renderTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingThree">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseThree"
                                                aria-expanded="false" aria-controls="flush-collapseThree">
                                            Phenotypes ({phenotypeData.length})
                                        </button>
                                    </h2>
                                    <div id="flush-collapseThree" className="accordion-collapse collapse"
                                        aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <input type="text" placeholder="Search" onChange={(e) => setPhenotyeTerm(e.target.value)}/>
                                            <table className="table">
                                                <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Prop</th>
                                                    <th scope="col">Val</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredPhenotypeData.map((data) => renderPhenoTableRow(data))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : <div className="no-data">
                            <h3>Select a strain to see its details</h3>
                                <Link className="link" to='../strains'>
                                    Go to Strains
                                </Link>
                        </div>
                        }

                    </div>
                    {id && <div className="col right">
                        <h3>Strain Genome View</h3>
                        <div id="my-viewer"></div>
                        
                    </div>}
                </div>
            </div>
        </div>
    );
}
